import {
  queryPoliciesCountForDatasource,
  mapQueryPoliciesCountForDatasource,
  IGetDatasourcePoliciesCountParams,
  queryPiiEmailsCount,
  mapQueryPiiEmailsCount,
  mapQueryFileSharesCount,
  queryFileSharesCount
} from './queries'
import graphqlService from '../../services/graphqlService'
import { UNIQUE_WIDGET_INDEX } from '../dashboards/mainDashboardv2/constants'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export interface SummaryCountsState {
  policiesCount?: {
    [key: string]: number
  }
  piiEmailsCount?: {
    [key: string]: number
  }
  fileSharesCount?: {
    [key: string]: number
  }
  inboxEmailCount?: {
    [key: string]: number
  }
  sentEmailsCount?: {
    [key: string]: number
  }
}

export const initialState: SummaryCountsState = {}

export const ACTION_SUMMARY_COUNT_PII_MAILS = 'mails/pii/count'
export const fetchPiiEmailsCount = createAsyncThunk(
  ACTION_SUMMARY_COUNT_PII_MAILS,
  async (params: IGetDatasourcePoliciesCountParams) => {
    const resultRaw = await graphqlService.execute(queryPiiEmailsCount(params))
    return mapQueryPiiEmailsCount(resultRaw)
  }
)

export const ACTION_SUMMARY_COUNT_POLICIES = 'datasource/policies/count'
export const fetchDatasourcePoliciesCount = createAsyncThunk(
  ACTION_SUMMARY_COUNT_POLICIES,
  async (params: IGetDatasourcePoliciesCountParams) => {
    const resultRaw = await graphqlService.execute(queryPoliciesCountForDatasource(params))
    return mapQueryPoliciesCountForDatasource(resultRaw)
  }
)

export interface FileSharesCountParams {
  datasourceId: string
}
export const fetchFileSharesCount = createAsyncThunk(
  'datasource/smb/summary/counts',
  async (params: FileSharesCountParams) => {
    const resultRaw = await graphqlService.execute(queryFileSharesCount(params))
    return mapQueryFileSharesCount(resultRaw)
  }
)

const dashboardSummarySlice = createSlice({
  name: 'dashboardSummary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDatasourcePoliciesCount.fulfilled, (state, { payload, meta }) => {
      const widgetIndex = meta?.arg?.[UNIQUE_WIDGET_INDEX]
      state.policiesCount = {
        ...state.policiesCount,
        [widgetIndex]: payload.policiesCount || 0
      }
    })
    builder.addCase(fetchPiiEmailsCount.fulfilled, (state, action) => {
      const widgetIndex = action.meta?.arg?.[UNIQUE_WIDGET_INDEX]
      state.piiEmailsCount = {
        ...state.piiEmailsCount,
        [widgetIndex]: action.payload.emailsCount
      }
      state.sentEmailsCount = {
        ...state.sentEmailsCount,
        [widgetIndex]: action.payload.sentCount
      }
      state.inboxEmailCount = {
        ...state.inboxEmailCount,
        [widgetIndex]: action.payload.inboxCount
      }
    })
    builder.addCase(fetchFileSharesCount.fulfilled, (state, action) => {
      const widgetIndex = action.meta?.arg?.[UNIQUE_WIDGET_INDEX]
      state.fileSharesCount = {
        ...state.fileSharesCount,
        [widgetIndex]: action.payload
      }
    })
  }
})

export default dashboardSummarySlice.reducer
